<template>
  <div>
    <!-- 整个单子费用调整名义设置 -->
    <el-dialog :title="$t('message.chargeAdjustmentNominalSettingsThroughoutTheList')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="680px" center>
      <div class="content">
        <!-- 添加 -->
        <div class="row">
          <el-button type="success" size="small" @click="add" v-if="isAuth(334)">{{
            $t("message.add")
          }}</el-button>
        </div>

        <div class="table">
          <ol>
            <!-- ID -->
            <li>ID</li>
            <!-- 名义设置 -->
            <li class="flex2">
              {{ $t("message.nominalSetting") }}
            </li>
            <!-- 操作 -->
            <li>
              {{ $t("message.operation") }}
            </li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <!-- ID -->
            <li>{{ item.id }}</li>
            <!-- 名义设置 -->
            <li class="flex2">
              <el-input v-model="item.name" @blur="configFeeTypeSet(item)"></el-input>
            </li>
            <!-- 操作 -->
            <li>
              <el-button type="success" size="small" class="dark" @click="configFeeTypeDelete(item.id, index)"
                v-if="isAuth(335)">{{
                  $t("message.delete") }}</el-button>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      tableData: [],
    };
  },
  methods: {
    //列表
    configFeeTypeList() {
      this.$api.capitalApi.configFeeTypeList().then((res) => {
        this.tableData = res.data;
      });
    },
    //售后-调整名义-设置
    configFeeTypeSet(item) {
      this.$api.capitalApi.configFeeTypeSet(item).then((res) => {
        this.$message.success(res.msg);
        this.configFeeTypeList();
      });
    },
    //新增
    add() {
      this.tableData.push({
        id: 0,
        name: "",
      });
    },
    //删除
    configFeeTypeDelete(id, i) {
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          if (id == 0) {
            this.tableData.splice(i, 1);
          } else {
            this.$api.capitalApi.configFeeTypeDelete({ id }).then((res) => {
              this.configFeeTypeList();
              // 操作成功
              this.$message.success(res.msg);
            });
          }
        })
        .catch(() => { });
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.configFeeTypeList();
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px 30px;

  .row {
    text-align: right;
    margin-bottom: 20px;
  }

  .table {
    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;
      border: 0;

      li {
        padding: 24px 0;
      }
    }

    .flex2 {
      flex: 4;
    }
  }

  /deep/.el-input {
    width: 80%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>